import api from '@/utils/api'
import { buildListQuery } from '@/utils/listQuery'

export default {
    getMatches(page, size) {
        let range = '?range=' + encodeURIComponent(`[${page - 1},${size}]`)
        return api.get(`matches` + (page ? range : ''))
    },
    getFilteredMatches(filter, page, size, sort) {
        return api.get(`matches` + buildListQuery({ filter, page, size, sort }))
    },

    getMatch(id) {
        return api.get(`matches/${id}`)
    },

    getMatchStats(id) {
        return api.get(`matches/${id}/stats`)
    },

    updateMatch(id, data) {
        return api.put(`matches/${id}`, data)
    },

    createMatch(data) {
        return api.post('matches', data)
    },

    uploadFile(formData, fileType) {
        return api.uploadFile('uploads/match-stats-' + fileType, formData)
    },

    importCsvStats(matchId, teamId, formData) {
        return api.post('matches/' + matchId + '/import-stats/' + teamId, formData)
    },

    importMatchLog(matchId, data) {
        return api.put('matches/' + matchId + '/import-match-log/', data)
    },

    deleteMatch(id) {
        return api.delete(`matches/${id}`)
    },

    getMatchLogs(matchId) {
        return api.get(`matches/${matchId}/logs`)
    },

    // the advanced stats of a shot in the feed ({ situation, playType, playerRole, shotType }); returns the feed
    updateShotDetails(matchId, logId, details) {
        return api.put(`matches/${matchId}/logs/${logId}/shot-details`, details)
    },

    deleteMatchLog(matchId, logId) {
        return api.delete(`matches/${matchId}/logs/${logId}`)
    },

    getActivePlayers(matchId) {
        return api.get(`matches/${matchId}/active-players`)
    },

    getPlayoffEligibility(matchId) {
        return api.get(`matches/${matchId}/playoff-eligibility`)
    },

    getActivePenalties(matchId) {
        return api.get(`matches/${matchId}/active-penalties`)
    },

    endMatch(matchId, data) {
        return api.post(`matches/${matchId}/stop-players`, data)
    },

    // what the live stream page shows (as it last reported it): { screen, reportedAt, serverTime }
    getLiveScreen(matchId) {
        return api.get(`matches/${matchId}/screen`)
    },

    // switches the live stream page to `screen`
    setLiveScreen(matchId, screen) {
        return api.post(`matches/${matchId}/screen`, { screen })
    },

    // the clock as it is now ({ timerEventStatus, timer, period }), empty before its first event
    getTimerState(matchId) {
        return api.get(`matches/${matchId}/timer`)
    },

    editTimer(matchId, eventStatus, time, quarter) {
        return api.post(`matches/${matchId}/timer`, { timerEventStatus: eventStatus, timer: time, period: quarter })
    },

    deleteAllLogs(matchId) {
        return api.delete(`matches/${matchId}/match-stats`)
    },

    createYoutubeLive(data, id) {
        return api.post(`matches/${id}/create-broadcast`, data)
    },

    // the matches of the current filters as a CSV file
    downloadMatchesCSV(filter) {
        return api.get(`matches/export` + buildListQuery({ filter }))
    },

    uploadMatchesCSV(formData) {
        return api.uploadFile('matches/import', formData)
    },

    togglePublishedOnSocial(matchId, publishedOnSocial) {
        return api.post(`matches/${matchId}/toggle-publish-on-social`, { publishedOnSocial })
    },

    // the play time of the players of every match again, from the play-by-play
    fixPlayTime() {
        return api.post('matches/fix-play-time')
    }
}
